var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSettingsFilled = function SvgSettingsFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.313 12.882A7.138 7.138 0 0 1 5.25 12c0-.297.027-.594.063-.882L3.725 9.876a.898.898 0 0 1-.224-1.156l1.412-2.443a.898.898 0 0 1 1.112-.384l1.421.571a.917.917 0 0 0 .847-.098c.22-.145.448-.28.684-.4a.92.92 0 0 0 .509-.682l.218-1.514a.897.897 0 0 1 .888-.77h2.817c.446 0 .825.328.888.77l.216 1.512c.043.3.241.547.512.683.235.118.462.251.681.396a.918.918 0 0 0 .85.102l1.419-.57a.898.898 0 0 1 1.112.384l1.412 2.443a.898.898 0 0 1-.224 1.156l-1.588 1.242c.036.288.063.585.063.882 0 .297-.027.594-.063.882l1.588 1.242a.898.898 0 0 1 .224 1.156l-1.412 2.443a.899.899 0 0 1-1.112.384l-1.419-.57a.915.915 0 0 0-.85.102 6.597 6.597 0 0 1-.681.396.918.918 0 0 0-.512.683l-.217 1.512a.897.897 0 0 1-.888.77h-2.817a.897.897 0 0 1-.888-.77l-.217-1.513a.916.916 0 0 0-.509-.682 6.863 6.863 0 0 1-.684-.4.912.912 0 0 0-.846-.099l-1.422.571a.898.898 0 0 1-1.112-.384L3.501 15.28a.898.898 0 0 1 .224-1.156l1.588-1.242Zm9.076 1.508A3.45 3.45 0 1 0 9.51 9.51a3.45 3.45 0 0 0 4.88 4.88Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsFilled);
export default ForwardRef;